(function () {
  if (window.__otrAbScenes) return;
  window.__otrAbScenes = true;
  function applySet(set, index) {
    var imgs = set.querySelectorAll('[data-otr-ab-img]');
    if (!imgs.length) return;
    var idx = ((index % imgs.length) + imgs.length) % imgs.length;
    imgs.forEach(function (img, i) {
      img.hidden = i !== idx;
    });
    var group = set.getAttribute('data-otr-ab-set');
    document.querySelectorAll('[data-otr-ab-pick="' + group + '"]').forEach(function (button) {
      button.classList.toggle('is-active', Number(button.getAttribute('data-otr-ab-index')) === idx);
    });
  }

  function storedIndex(group, count) {
    var key = 'otrAbScene:' + group;
    var raw = null;
    try { raw = window.localStorage.getItem(key); } catch (e) {}
    var idx = raw == null || raw === '' ? Math.floor(Math.random() * count) : Number(raw);
    if (!(idx >= 0 && idx < count)) idx = 0;
    try { window.localStorage.setItem(key, String(idx)); } catch (e) {}
    return idx;
  }

  function init(root) {
    (root || document).querySelectorAll('[data-otr-ab-set]').forEach(function (set) {
      if (set.dataset.otrAbReady === '1') return;
      set.dataset.otrAbReady = '1';
      var count = set.querySelectorAll('[data-otr-ab-img]').length || 1;
      applySet(set, storedIndex(set.getAttribute('data-otr-ab-set'), count));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-otr-ab-pick]');
    if (!button) return;
    var group = button.getAttribute('data-otr-ab-pick');
    var index = Number(button.getAttribute('data-otr-ab-index'));
    try { window.localStorage.setItem('otrAbScene:' + group, String(index)); } catch (e) {}
    document.querySelectorAll('[data-otr-ab-set="' + group + '"]').forEach(function (set) {
      applySet(set, index);
    });
  });

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
